import { z } from 'zod/v4';

export const TemplateItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  composedOf: z.array(z.string()),
  setup: z.array(z.unknown()),
  type: z.string(),
  createdAt: z.coerce.date().nullable(),
  createdByUserId: z.string().nullable(),
  createdByUserName: z.string().nullable(),
  createdByImpersonateId: z.string().nullable(),
  createdByCompanyId: z.string().nullable(),
  updatedAt: z.coerce.date().nullable(),
  updatedByUserId: z.string().nullable(),
  updatedByUserName: z.string().nullable(),
  updatedByImpersonateId: z.string().nullable(),
  updatedByImpersonateName: z.string().nullable(),
  updatedByCompanyId: z.string().nullable(),
  updatedByCompanyName: z.string().nullable(),
  createdByApiKeyId: z.string().nullable(),
  createdByApiKeyLabel: z.string().nullable(),
  updatedByApiKeyId: z.string().nullable(),
  updatedByApiKeyLabel: z.string().nullable(),
});

export type TemplateItem = z.infer<typeof TemplateItemSchema>;
